export default __webpack_public_path__ + "static/media/05.66173c2e.jpg";